import React, { useEffect } from "react";
import "../Login.css";
import { Form, Input, Button, Checkbox, Row, Col, Typography } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../features/auth/authSlice";

let schema = yup.object().shape({
  email: yup
    .string()
    .email("Email should be valid")
    .required("Email is Required"),
  password: yup.string().required("Password is Required"),
});

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      dispatch(login(values));
    },
  });

  const authState = useSelector((state) => state);
  const { user, isError, isSuccess, isLoading, message } = authState.auth;

  useEffect(() => {
    if (isSuccess) {
      //navigate("admin");
      window.location.href = "admin";
    } else {
      navigate("/");
    }
  }, [user, isError, isSuccess, isLoading]);

  const backgroundImageUrl = `${process.env.PUBLIC_URL}/admin-login.png`;

  return (
    <Row style={{ minHeight: "100vh" }}>
      <Col
        xs={0}
        sm={0}
        md={12}
        style={{
          background: `url(${backgroundImageUrl}) no-repeat center center`,
          backgroundSize: "cover",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#fff",
        }}
      ></Col>
      <Col xs={24} sm={24} md={12} className="right-block">
        <div className="login-card">
          {/* Top accent bar */}
          <div className="login-card-accent" />

          <div className="text-center" style={{ marginBottom: 12 }}>
            <img
              src={`${process.env.PUBLIC_URL}/LNG_SKILLS_LOGO.png`}
              alt="LNJ Skills"
              style={{ width: 64, height: 56, objectFit: "contain" }}
            />
          </div>
          <Typography.Title level={3} className="text-center">
            Welcome Back
          </Typography.Title>
          <Typography.Text className="text-center login-subtitle" type="secondary">
            Sign in to your admin account
          </Typography.Text>

          <div className="error text-center">
            {message.message === "Rejected" ? "Invalid Credentials" : ""}
          </div>
          <Form
            layout="vertical"
            onFinish={formik.handleSubmit}
            initialValues={{ remember: true }}
          >
            <Form.Item
              label="Email"
              name="email"
              validateStatus={formik.errors.email && formik.touched.email ? "error" : ""}
              help={formik.errors.email && formik.touched.email ? formik.errors.email : ""}
            >
              <Input
                id="email"
                name="email"
                prefix={<MailOutlined style={{ color: "#4f46e5" }} />}
                placeholder="Enter your email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              validateStatus={formik.errors.password && formik.touched.password ? "error" : ""}
              help={formik.errors.password && formik.touched.password ? formik.errors.password : ""}
            >
              <Input.Password
                id="password"
                name="password"
                prefix={<LockOutlined style={{ color: "#4f46e5" }} />}
                placeholder="Enter your password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
            </Form.Item>

            <Form.Item>
              <Row justify="space-between" align="middle">
                <Col>
                  <Form.Item name="remember" valuePropName="checked" noStyle>
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>
                </Col>
                <Col>
                  <a href="/forgot-password">Forgot Password?</a>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" block loading={isLoading}>
                Sign In
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  );
};

export default Login;
